<template>
  <!-- 官网底部：站点导航 + 联系方式 + 版权 -->
  <footer class="site-footer">
    <div class="container footer-inner">
      <div class="footer-col">
        <h4>{{ name }}</h4>
        <p>{{ config.about_brief || '专注为客户提供优质的产品与服务，用技术创造价值。' }}</p>
      </div>

      <div class="footer-col">
        <h4>快速导航</h4>
        <router-link to="/" class="footer-link">首页</router-link>
        <router-link to="/products" class="footer-link">产品中心</router-link>
        <router-link to="/news" class="footer-link">新闻动态</router-link>
        <router-link to="/about" class="footer-link">关于我们</router-link>
      </div>

      <div class="footer-col">
        <h4>联系我们</h4>
        <p v-if="config.phone"><i class="el-icon-phone"></i> {{ config.phone }}</p>
        <p v-if="config.email"><i class="el-icon-message"></i> {{ config.email }}</p>
        <p v-if="config.address"><i class="el-icon-location"></i> {{ config.address }}</p>
      </div>
    </div>

    <div class="footer-bottom">
      <div class="container">
        © {{ year }} {{ name }} 版权所有
        <span v-if="config.icp" class="icp">{{ config.icp }}</span>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter',
  props: {
    // 站点配置：来自后台「站点配置」，App.vue 传入
    config: { type: Object, default: () => ({}) }
  },
  data() {
    // 版权年份取当前年份，免得每年手动改
    return { year: new Date().getFullYear() }
  },
  computed: {
    name() {
      return this.config.site_name || '示例科技'
    }
  }
}
</script>

<style scoped>
.site-footer {
  margin-top: 60px;
  background: #1f2d3d;
  color: #a6adb4;
  font-size: 14px;
}
.footer-inner {
  display: flex;
  flex-wrap: wrap;
  gap: 40px;
  padding: 40px 0;
}
.footer-col { flex: 1; min-width: 220px; }
.footer-col h4 {
  margin: 0 0 16px;
  color: #ffffff;
  font-size: 16px;
}
.footer-col p { margin: 8px 0; line-height: 1.6; }
.footer-col i { margin-right: 6px; }
.footer-link {
  display: block;
  margin: 8px 0;
  color: #a6adb4;
}
.footer-link:hover { color: #ffffff; }
.footer-bottom {
  border-top: 1px solid #2c3e50;
  padding: 16px 0;
  text-align: center;
  font-size: 13px;
}
.icp { margin-left: 12px; }
</style>
